import { useEffect, useRef } from "react";

// time should be in milliseconds always
export const useIdle = ({ time, cb }: { time: number; cb: () => void }) => {
  const timerRef = useRef<null | NodeJS.Timeout>(null);

  const callbackRef = useRef(cb);

  // keep latest callback without re-registering listeners
  useEffect(() => {
    callbackRef.current = cb;
  }, [cb]);

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(() => {
      callbackRef.current();
    }, time);
  };
  useEffect(() => {
    const events = ["mousemove", "mouseup", "keydown", "scroll"];
    events.forEach((event) => window.addEventListener(event, resetTimer));
    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [time]);
};
